/**
 * Pure patient access / reopen / A2HS policy (no DOM).
 * Used by patientRoomAccess + smoke tests.
 */

function isPatientFacingPath(pathname = '') {
    const p = String(pathname || '');
    return (
        p.startsWith('/SRM_IP/')
        || p.startsWith('/customer/')
        || p.startsWith('/srm_ward/')
        || p.startsWith('/srm_head/')
        || p.startsWith('/custom/')
        || p === '/patient-home'
        || p.startsWith('/kiosk_srm/customer')
    );
}

/** Bed landing only — never ephemeral WebRTC call room ids. */
function isStablePatientEntryPath(pathname = '') {
    const p = String(pathname || '');
    return (
        /^\/SRM_IP\/patient\/[^/]+\/[^/]+/.test(p)
        || /^\/SRM_IP\/custom\/[^/]+/.test(p)
        || /^\/custom\/[^/]+$/.test(p)
        || /^\/kiosk_srm\/[^/]+$/.test(p)
    );
}

/**
 * After kill/reopen: Home Screen opens /patient-home → restore last scanned bed.
 * @returns {string|null} path to open, or null
 */
function resolveSavedRoomRedirect({ currentPath, savedEntry }) {
    const path = String(currentPath || '');
    if (path !== '/patient-home' && path !== '/patient-home/') {
        return null;
    }
    const saved = String(savedEntry || '').trim();
    if (!saved) {
        return null;
    }
    const savedPath = saved.split('?')[0];
    if (!isStablePatientEntryPath(savedPath)) {
        return null;
    }
    if (path === savedPath || path === saved) {
        return null;
    }
    return saved;
}

/**
 * Call must wait for Add-to-Home popup when vendor enabled and not installed PWA.
 */
function shouldBlockCallForA2hs({
    vendorEnabled = true,
    isPwa = false,
    sessionAnswered = false,
    gateBlocking = false,
} = {}) {
    if (isPwa) {
        return false;
    }
    if (!vendorEnabled) {
        return false;
    }
    return !sessionAnswered || gateBlocking;
}

/**
 * Auto-call on room load: wait for A2HS when vendor Yes and not PWA.
 */
function shouldWaitForA2hsBeforeAutoCall({
    vendorAddToHomeEnabled = true,
    isPwa = false,
    immediateConnect = false,
    blockAutoCall = false,
} = {}) {
    if (!immediateConnect || blockAutoCall) {
        return false;
    }
    if (isPwa) {
        return false;
    }
    return !!vendorAddToHomeEnabled;
}

/**
 * Why QR "new tab" disappears after Recent-apps kill:
 * temporary Custom Tab / cold Chrome start does not restore that tab.
 * Durable reopen = Home Screen shortcut → /patient-home → saved room.
 */
function explainPatientTabDisappearReason() {
    return 'temporary-browser-session';
}

module.exports = {
    isPatientFacingPath,
    isStablePatientEntryPath,
    resolveSavedRoomRedirect,
    shouldBlockCallForA2hs,
    shouldWaitForA2hsBeforeAutoCall,
    explainPatientTabDisappearReason,
};
